class TinkerDate extends HTMLElement {
  constructor() {
    super();
    this.selectedDate = null;
    this._isOpen = false;
  }

  get value() { return this.hiddenInput ? this.hiddenInput.value : ''; }
  set value(val) { if(val) this.selectDate(new Date(val), false); }

  connectedCallback() {
    setTimeout(() => {
        this.injectStyles();
        this.init();
        this.observeChanges(); // <--- Start watching for "Morph" deletions
    }, 0);
  }

  init() {
    this.minDateStr = this.getAttribute('min-date');
    this.initialValue = this.getAttribute('initial-value');
    this.name = this.getAttribute('name') || 'date';
    
    // Only render if we haven't already
    if (!this.querySelector('.tinker-datepicker-wrapper')) {
        this.render();
    }
    
    this.inputDisplay = this.querySelector('.tinker-date-display');
    this.hiddenInput = this.querySelector('input[type="hidden"]');
    this.popup = this.querySelector('.tinker-date-popup');
    this.gridDays = this.querySelector('.days-grid');
    this.monthLabel = this.querySelector('.month-label');
    
    this.currentCalendarDate = this.initialValue ? new Date(this.initialValue) : new Date();
    if (this.initialValue) this.selectDate(this.currentCalendarDate, false);

    // Re-bind events (Morphing might strip event listeners even if elements stay)
    if(this.inputDisplay) {
        // Clone and replace to strip old listeners to prevent duplicates
        const newDisplay = this.inputDisplay.cloneNode(true);
        this.inputDisplay.parentNode.replaceChild(newDisplay, this.inputDisplay);
        this.inputDisplay = newDisplay;
        this.inputDisplay.addEventListener('click', (e) => { e.stopPropagation(); this.toggle(); });
    }

    const prevBtn = this.querySelector('.prev-btn');
    const nextBtn = this.querySelector('.next-btn');
    if(prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.changeMonth(-1); });
    if(nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.changeMonth(1); });

    document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });
  }

  observeChanges() {
    // Watch for the Theme wiping out our content
    this.observer = new MutationObserver((mutations) => {
        // If the wrapper is gone, the theme wiped us. Re-init.
        if (!this.querySelector('.tinker-datepicker-wrapper')) {
            this.init();
        }
    });
    this.observer.observe(this, { childList: true });
  }

  injectStyles() {
    if (document.getElementById('tinker-date-styles')) return;
    const style = document.createElement('style');
    style.id = 'tinker-date-styles';
    style.textContent = `
      .tinker-datepicker-wrapper { position: relative; width: 100%; }
      .tinker-date-display {
        width: 100%; padding: 12px 16px; border: 1px solid rgba(0,0,0,0.12);
        border-radius: 1.7rem; font-size: 14px; background: #fff; cursor: pointer;
        transition: border-color 0.2s;
      }
      .tinker-date-display:hover { border-color: rgba(0,0,0,0.4); }
      .tinker-date-popup {
        position: absolute; top: 110%; left: 0; width: 280px;
        background: white; border: 1px solid #eee; border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1); z-index: 1000; padding: 12px;
        opacity: 0; transform: translateY(-10px); pointer-events: none;
        transition: opacity 0.2s ease, transform 0.2s ease;
      }
      .tinker-date-popup.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }
      .calendar-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; font-weight: bold; }
      .nav-btn { background: none; border: none; font-size: 18px; cursor: pointer; padding: 4px 8px; color: #333; }
      .days-header, .days-grid { display: grid; grid-template-columns: repeat(7, 1fr); text-align: center; font-size: 13px; }
      .days-header { color: #888; margin-bottom: 6px; font-weight: 500; }
      .day-btn { background: none; border: none; padding: 8px 0; cursor: pointer; border-radius: 6px; font-size: 14px; color: #333; }
      .day-btn:hover:not(.disabled) { background: #f4f4f4; }
      .day-btn.selected { background: #000; color: #fff; }
      .day-btn.disabled { color: #ccc; cursor: not-allowed; }
    `;
    document.head.appendChild(style);
  }

  toggle() { this._isOpen ? this.close() : this.open(); }
  open() { this._isOpen = true; if(this.popup) this.popup.classList.add('is-open'); this.renderCalendar(); }
  close() { this._isOpen = false; if(this.popup) this.popup.classList.remove('is-open'); }
  changeMonth(delta) { this.currentCalendarDate.setMonth(this.currentCalendarDate.getMonth() + delta); this.renderCalendar(); }

  selectDate(dateObj, triggerEvent = true) {
    const offset = dateObj.getTimezoneOffset();
    const localDate = new Date(dateObj.getTime() - (offset * 60 * 1000));
    const dateString = localDate.toISOString().split('T')[0];
    this.selectedDate = dateObj;
    if(this.inputDisplay) this.inputDisplay.value = dateString;
    if(this.hiddenInput) this.hiddenInput.value = dateString;
    this.close();
    if (triggerEvent) this.dispatchEvent(new Event('change', { bubbles: true }));
  }

  renderCalendar() {
    const year = this.currentCalendarDate.getFullYear();
    const month = this.currentCalendarDate.getMonth();
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    if(this.monthLabel) this.monthLabel.textContent = `${monthNames[month]} ${year}`;
    
    const firstDayIndex = new Date(year, month, 1).getDay();
    const lastDay = new Date(year, month + 1, 0).getDate();
    const minDateObj = new Date(this.minDateStr);
    minDateObj.setHours(0,0,0,0);

    if(!this.gridDays) return;
    this.gridDays.innerHTML = "";
    
    for (let i = 0; i < firstDayIndex; i++) this.gridDays.appendChild(document.createElement("div"));
    for (let i = 1; i <= lastDay; i++) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = i;
        btn.classList.add("day-btn");
        const currentDate = new Date(year, month, i);
        currentDate.setHours(0,0,0,0);
        if (currentDate < minDateObj) { btn.classList.add("disabled"); btn.disabled = true; } 
        else { btn.addEventListener('click', (e) => { e.stopPropagation(); this.selectDate(currentDate); }); }
        if (this.selectedDate && currentDate.getTime() === this.selectedDate.getTime()) btn.classList.add("selected");
        this.gridDays.appendChild(btn);
    }
  }

  render() {
    // Preserve existing value if possible during re-render
    const existingVal = this.value || '';
    this.innerHTML = `
      <div class="tinker-datepicker-wrapper">
        <input type="text" class="tinker-date-display" placeholder="Select Date" readonly>
        <input type="hidden" name="${this.name}" value="${existingVal}">
        <div class="tinker-date-popup">
          <div class="calendar-header">
            <button type="button" class="nav-btn prev-btn">&lt;</button>
            <span class="month-label"></span>
            <button type="button" class="nav-btn next-btn">&gt;</button>
          </div>
          <div class="days-header"><span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span></div>
          <div class="days-grid"></div>
        </div>
      </div>
    `;
  }
}
customElements.define('tinker-date', TinkerDate);